import React from "react";
import {Spin} from "antd";
import {SubCompanyInvoiceRow} from "./SubCompanyInvoiceRow";
import {SubCompanyRows, EmptyText} from "../styles/SubCompanyInvoice.styles";

export const SubCompanyInvoiceList = ({state, filters, fetchDetail}) => {
    if (!state || state.loading) {
        return (
            <EmptyText>
                <Spin size="small" />
            </EmptyText>
        );
    }
    if (state.error) return <EmptyText>{state.error}</EmptyText>;
    if (!state.data?.length)
        return <EmptyText>Bu firmaya ait alt firma faturası bulunamadı.</EmptyText>;

    return (
        <SubCompanyRows>
            {state.data.map(subCompany => (
                <SubCompanyInvoiceRow
                    key={subCompany.subCompanyId}
                    subCompany={subCompany}
                    filters={filters}
                    fetchDetail={fetchDetail}
                />
            ))}
        </SubCompanyRows>
    );
};
